import { useParams } from "react-router-dom";
import styled from "styled-components";
import Heading from "../ui/Heading";
import { useContract } from "../features/contract/useContract";
import ContractOperation from "../features/contract/ContractOperation";
import ContractDescription from "../features/contract/ContractDescription";
import ThemedSkeleton from "../ui/ThemedSkeleton";
import { toPascalCase } from "../utils/helpers";
import ResizableChat from "@/features/chat/ResizableChat";

const ShadowContainer = styled.div`
  background-color: var(--gray-50);
  margin-bottom: 1.6rem;
  border: 1px solid var(--gray-200);
  border-radius: var(--border-radius-xlg);
  padding: 1.5rem 2.4rem;
  box-shadow: var(--shadow-md);
`;

function Contract({ contract, isLoading }) {
  return (
    <ShadowContainer>
      <Heading as="h3" className="mb-4">
        {isLoading ? (
          <ThemedSkeleton />
        ) : (
          toPascalCase(
            contract?.Title || contract?.title || contract?.opportunityTitle
          )
        )}
      </Heading>
      <ContractOperation isLoading={isLoading} contract={contract} />
      <ContractDescription contract={contract} isLoading={isLoading} />
    </ShadowContainer>
  );
}
function ContractChat() {
  const { searchType, proposal_id } = useParams();
  const { data: contract, isLoading } = useContract(proposal_id, searchType);

  return (
    <ResizableChat
      proposal_id={proposal_id}
      searchType={searchType}
      purpose={"chat"}
    >
      <Contract contract={contract} isLoading={isLoading} />
    </ResizableChat>
  );
}

export default ContractChat;
